import React from "react";
import EventSummarySkeleton from "../EventSummary/EventSummarySkeleton";
import EventBroaderContextSkeleton from "../EventBroaderContext/EventBroaderContextSkeleton";
import Section from "../Section/Section";
import styles from "../EventSummary/EventSummary.module.css";
import Skeleton from "@mui/material/Skeleton";

const EventContentSkeleton: React.FC = () => {
  return (
    <>
      <EventSummarySkeleton />

      <Section>
        <div className={styles["secondary-header"]}>
          <Skeleton variant="text" width="20%" height={40} />
        </div>
        <EventBroaderContextSkeleton />
      </Section>
    </>
  );
};

export default EventContentSkeleton;
